module.exports = __webpack_public_path__ + "static/media/michelle_kou.659889be.png";